import React, { useEffect, useState } from "react";

import { Typography } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import CommonTextField from "../../../../component/Input";
import { HandleSkeletion } from "../../../../utils/constants";

export default function PreScreenQuestion({ loading }) {
  const { values, errors, setFieldValue, handleChange } = useFormikContext();

  const debounceTimer = React.useRef(null);
  const [questionData, setQuestionData] = useState(
    values["pre_screen_question_answers"]
  );
  useEffect(() => {
    setQuestionData(values["pre_screen_question_answers"]);
  }, [values]);

  const handleListChange = (e, index) => {
    const newAnswer = e.target.value;
    const updatedQuestions = values.pre_screen_question_answers.map((item, i) =>
      i === index ? { ...item, answer: newAnswer } : item
    );

    setQuestionData(updatedQuestions);

    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      setFieldValue("pre_screen_question_answers", updatedQuestions);
    }, 500);
  };

  return (
    <CommonGrid2 container spacing={2.5}>
      {questionData &&
        questionData.map((item, index) =>
          loading ? (
            <HandleSkeletion height={50} width={"100%"} transform="scale(1)" />
          ) : (
            <CommonGrid2
              item
              size={12}
              display={"flex"}
              flexDirection={"column"}
              gap={"5px"}
            >
              <Typography variant="h6">
                Q{index + 1}: {item.question}
              </Typography>

              <CommonTextField
                placeholder={"Enter the answer"}
                disabled={true}
                padding="13px"
                placeholderFontSize={"15px"}
                value={item.answer}
                backgroundColor={"#F9FAFB"}
              />
            </CommonGrid2>
          )
        )}
    </CommonGrid2>
  );
}
